import React, { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import api from "@/lib/api";

// مقياس الحمل اللحظي لخادم التوليد (نسخة الخادم الحالية)
export const AdminLoad = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/load").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const pct = Math.min(100, Math.round((d.active / d.max_active) * 100));
  const tone = d.queued > 0 ? "text-destructive" : pct >= 70 ? "text-accent" : "text-emerald-400";
  return (
    <section className="glass rounded-2xl border border-border p-5" data-testid="admin-load">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className="text-lg font-bold flex items-center gap-2"><Gauge className="w-5 h-5 text-primary" /> حمل خادم التوليد الآن</h2>
        <span className={`text-sm font-bold ${tone}`} data-testid="admin-load-status">
          {d.queued > 0 ? `طابور: ${d.queued} بانتظار الدور` : pct >= 70 ? "ضغط مرتفع" : "طبيعي"}
        </span>
      </div>
      <div className="mt-3 h-2.5 rounded-full bg-secondary overflow-hidden border border-border">
        <div className="h-full rounded-full bg-gradient-to-l from-accent to-primary transition-[width]" style={{ width: `${pct}%` }} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-4 text-center text-sm">
        {[["فيديوهات نشطة", `${d.active} / ${d.max_active}`, "active"], ["في الطابور", d.queued, "queued"], ["ذروة التزامن", d.peak_active, "peak"],
          ["ذروة الطابور", d.peak_queued, "peak-queued"], ["ذاكرة الذروة", `${d.peak_rss_mb} MB`, "rss"]].map(([l, v, id]) => (
          <div key={id} className="rounded-xl bg-secondary/40 border border-border p-3" data-testid={`admin-load-${id}`}>
            <div className="text-xl font-extrabold">{v}</div>
            <div className="text-[11px] text-muted-foreground">{l}</div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-3">إذا تكرّر ظهور الطابور أو تجاوزت ذروة التزامن {d.max_active} بانتظام → ارفع فئة الموارد (Grow) من لوحة النشر.</p>
    </section>
  );
};
